import React from 'react';

import { NumberFields } from 'jbc-front/components/Form';
import { useTranslation } from 'react-i18next';

const TelField = ({ required, disabled }) => {
  const { t } = useTranslation();
  return (
    <NumberFields
      texts={['', ' - ']}
      lengths={[4, 4, 4]}
      required={required}
      disabled={disabled}
      label={t('components.TelField.Phone_number')}
      seperateChar=""
      prefix="telPart"
    />
  )
};

export default TelField;
